import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useAuthStore } from '../auth/auth.store';

export function AdminLayout() {
  const hasPermission = useAuthStore((s) => s.hasPermission);

  return (
    <div className="bg-ink-50 flex min-h-screen">
      <Sidebar hasPermission={hasPermission} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto px-6 py-8 lg:px-10">
          <div className="animate-fade-in mx-auto max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
